/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const printTemplate = {
  /**
   *  AJAX-添加打印模板
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(info,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_PRINT,
      {
        pageTypeName: info.name,
        pageWidth: info.width,
        pageHeight: info.height,
        pageTop: info.top,
        pageLeft: info.left,
        pageRight: info.right,
        pageBottom: info.bottom,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除打印模板
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  delete(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_PRINT,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改打印模板
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_PRINT,
      {
        pageTypeName: info.name,
        pageWidth: info.width,
        pageHeight: info.height,
        pageTop: info.top,
        pageLeft: info.left,
        pageRight: info.right,
        pageBottom: info.bottom,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取打印模板列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  list(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PRINT,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default printTemplate;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-print-template.js